import { Row } from "@components/Layout";
import { Image } from "@kobalte/core";
import { styled } from "solid-styled-components";

export const MobileTrackWrapper = styled(Row)`
    border-radius: 4px;
    background: ${({ theme }) => theme?.embed.activeTrack};
    cursor: pointer;
`;
export const TrackImage = styled(Image.Root)`
    width: 40px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    flex-shrink: 0;
    cursor: pointer;
    & > * {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
`;
